import { Typography, Card, ListItemIcon, ListItem } from '@mui/material';
import ListItemButton from '@mui/material/ListItemButton';
import { ElementType } from 'react';

interface CardElementProps {
  text: string;
  action?: () => void;
  icon: any;
  isButton?: boolean;
}

export function CardElement(props: CardElementProps) {
  const { text, action, icon, isButton = true } = props;
  const ItemComponent: ElementType = isButton ? ListItemButton : ListItem;

  return (
    <Card sx={{ marginTop: '10px', padding: '8px' }}>
      <ItemComponent onClick={() => isButton && action && action()}>
        <ListItemIcon sx={{ color: 'secondary.main' }}>{icon}</ListItemIcon>
        <Typography sx={{ color: '#1f4a8f' }}>{text}</Typography>
      </ItemComponent>
    </Card>
  );
}
